import AppDefaultLayout from "./app-default-layout/base.vue";
import AppBackofficeLayout from "./app-backoffice-layout/base.vue";
import AppFullscreenLayout from "./app-fullscreen-layout/base.vue";
import RouteWrapper from "./RouteWrapper";

export { AppDefaultLayout, AppBackofficeLayout, AppFullscreenLayout, RouteWrapper };
